import { FC, useEffect } from 'react'
import styles from './GlobalNewsletterModal.module.scss'
import useI18n from '@/hooks/use-i18n'
import FormResult from '@/components/EmailSignupInput/FormResults/FormResults'
import RichText from '@/components/RichText/RichText'
import { headerSerializer, subtitleSerializer } from '@/sections/NewsletterSignUpSection/serializers'
import classNames from 'classnames'
import { useNewsletterForm } from '@/hooks/useNewsletterForm'
import { NewsletterFormFields } from '@/components/NewsletterFormFields/NewsletterFormFields'

interface NewsletterFormProps {
  onDismiss: () => void
  successMessage: {
    title: any[]
    subtitle: any[]
  }
  hasWhatToExpect?: boolean
}

const NewsletterForm: FC<NewsletterFormProps> = ({ onDismiss, successMessage, hasWhatToExpect }) => {
  const { i18n } = useI18n()

  const locations = [
    i18n('vancouverBritishColumbia'),
    i18n('californiaArcadia'),
    i18n('californiaCostaMesa'),
    i18n('californiaDowntownDisney'),
    i18n('californiaGlendale'),
    i18n('californiaLosAngeles'),
    i18n('californiaSanDiego'),
    i18n('californiaSantaClara'),
    i18n('californiaSantaMonica'),
    i18n('californiaTorrance'),
    i18n('nevadaLasVegas'),
    i18n('newYorkNyc'),
    i18n('oregonPortland'),
    i18n('oregonTigard'),
    i18n('washingtonBellevue'),
    i18n('washingtonSeattlePacificPlace'),
    i18n('washingtonSeattleUniversityVillage'),
    i18n('washingtonTukwila'),
  ]

  const {
    formData,
    errors,
    loading,
    formSubmitSuccess,
    formSubmit,
    handleChange,
    handleDateChange,
    handleSubmit,
    memberAlreadySubscribed,
  } = useNewsletterForm(onDismiss)

  // Add GTM event when form is successfully submitted
  useEffect(() => {
    if (formSubmitSuccess) {
      /**
       * SEND GTM EVENT
       */
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'newsletter_submission',
        formData: {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          location: formData.location,
          birthday: formData.birthday,
        },
      })
    }
  }, [formSubmitSuccess, formData])

  return (
    <>
      {formSubmitSuccess ? (
        <div className={styles.successMessageWrapper}>
          <RichText value={successMessage.title} components={headerSerializer} />
          <RichText value={successMessage.subtitle} components={subtitleSerializer} />
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className={classNames(styles.form, {
            [styles.formWithWhatToExpect]: hasWhatToExpect,
            [styles.formWithoutWhatToExpect]: !hasWhatToExpect,
          })}
        >
          <NewsletterFormFields
            formData={formData}
            errors={errors}
            loading={loading}
            locations={locations as string[]}
            handleChange={handleChange}
            handleDateChange={handleDateChange}
            inputClassName={styles.input}
            selectClassName={styles.select}
            rowClassName={styles.row}
            nameRowClassName={styles.nameRow}
            formFieldClassName={styles.formField}
            submitButtonClassName={styles.submitButton}
            errorClassName={styles.error}
          />

          {(formSubmit && !loading) && (
            <div className={styles.FormResults}>
              {formSubmitSuccess ? (
                <>
                </>
              ) : (
                <FormResult
                  status="error"
                  errorMessage={
                    <>
                      <p>{memberAlreadySubscribed ? i18n('emailAlreadySubscribed') : i18n('somethingWentWrong')}</p>
                    </>
                  }
                />
              )}
            </div>
          )}
        </form>
      )}
    </>
  )
}

export default NewsletterForm
